import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { createPasswordSchema } from 'utils/schema/authSchema'
import { Button, Spinner, TextInput } from 'components/common'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { resetPassword, validateForgotPasswordToken } from 'utils/api/auth'
import { PAGE_LOGIN, PAGE_NOT_FOUND } from 'utils/constants'
import toast from 'react-hot-toast'

type CreatePasswordFields = {
  password: string
  cpassword: string
}

const CreatePassword = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean>(true)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<CreatePasswordFields>({
    resolver: yupResolver(createPasswordSchema),
  })

  const verifyPasswordToken = async () => {
    try {
      if (id) {
        const { data } = await validateForgotPasswordToken(id)
        if (!data?.email) {
          navigate(PAGE_NOT_FOUND.path)
        }
      }
    } catch (error) {
      navigate(PAGE_NOT_FOUND.path)
    }
    setLoading(false)
  }

  useEffect(() => {
    verifyPasswordToken()
  }, [id])

  const handleResetPassword = async ({ password }: CreatePasswordFields) => {
    if (!id) return
    const resetToast = toast.loading('Setting new password..')
    try {
      await resetPassword({ id, password })
      toast.success('Password Changed Successfully', { id: resetToast })
      navigate(PAGE_LOGIN.path)
    } catch (error) {
      toast.error('Failed to Changed Password', { id: resetToast })
    }
  }

  if (loading) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center">
        <Spinner size="large" />
      </div>
    )
  }

  return (
    <section className="flex w-full items-center justify-center">
      <div className="w-full max-w-lg rounded-lg p-10">
        <div className="flex flex-col items-center text-center">
          <h1 className="mb-2 text-3xl font-bold">Create Password</h1>
          <h3 className="max-w-md text-center text-sm">
            Set Your new password so you can Login and access GAG.
          </h3>
        </div>
        <div className="mt-5">
          <form onSubmit={handleSubmit(handleResetPassword)}>
            <div className="flex flex-col gap-2">
              <TextInput
                required
                type="password"
                name="password"
                label="Password"
                register={register}
                error={errors?.password?.message}
                hintText="Atleast 8 characters, capital letter, small letter and symbol"
              />
              <TextInput
                required
                type="password"
                name="cpassword"
                label="Confirm Password"
                register={register}
                error={errors?.cpassword?.message}
                hintText="Both Password must be same"
              />
            </div>
            <Button buttonText="Reset Password" className="mt-4 w-full" />
          </form>
        </div>
      </div>
    </section>
  )
}

export default CreatePassword
